// =============================================================================
// FUENTE ÚNICA DE VERDAD para roles de usuario.
// Antes había 3 definiciones distintas (authService, db.ts, useAppStore) que
// causaban bugs de routing — todas ahora importan desde aquí.
// =============================================================================

export type UserRole =
  | 'PASSENGER'
  | 'DRIVER'
  | 'SCHOOL_DRIVER'
  | 'DELIVERY_DRIVER'
  | 'RENT_CAR_OWNER'
  | 'CAR_RENTER'
  | 'SCHOOL_DIRECTOR'
  | 'FOOD_DELIVERY'
  | 'RESTAURANT_OWNER'
  /**
   * @deprecated NO usar en código nuevo. El invitado conserva su rol REAL
   * (PASSENGER, DRIVER, …) y se identifica con la bandera `guestPreview` del
   * store. Guardar 'GUEST' como rol hacía que el invitado cayera en cada
   * `else` del código y viera paneles ajenos (ganancias de chofer, etc.).
   *
   * Solo sigue en el tipo para poder LEER instalaciones viejas que lo tengan
   * guardado en disco; el store lo convierte a `null` al rehidratar.
   */
  | 'GUEST';

export type UserStatus =
  | 'PENDING_KYC'
  | 'ACTIVE'
  | 'SUSPENDED_PAYMENT'
  | 'BANNED';

/** Roles que conducen (todos los flavors de "driver"). */
export const DRIVER_ROLES: UserRole[] = ['DRIVER', 'SCHOOL_DRIVER', 'DELIVERY_DRIVER'];

/** Roles que operan negocio (panel desktop / dashboards). */
export const BUSINESS_ROLES: UserRole[] = ['RENT_CAR_OWNER', 'RESTAURANT_OWNER', 'SCHOOL_DIRECTOR'];

export function isDriverRole(role: UserRole | null | undefined): boolean {
  return role != null && DRIVER_ROLES.includes(role);
}

export function isBusinessRole(role: UserRole | null | undefined): boolean {
  return role != null && BUSINESS_ROLES.includes(role);
}
